(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["limitless-experience-priority"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initialize(){document.querySelectorAll('[data-priority-deposit]').forEach(root=>{
    if(root.dataset.ready)return;root.dataset.ready='true';
    const form=root.querySelector('[data-priority-form]'),select=root.querySelector('[data-priority-month]'),button=root.querySelector('[data-priority-submit]');
    const sync=()=>{const unlocked=!!window.LimitlessCoachingPricing?.getPrices();root.querySelector('[data-priority-purchase]').hidden=!unlocked;button.disabled=!unlocked||root.dataset.release!=='true';};
    const selected=new URLSearchParams(location.search).get('variant');if(selected&&Array.from(select.options).some(o=>o.value===selected&&!o.disabled))select.value=selected;
    form.addEventListener('submit',event=>{sync();if(button.disabled||!form.checkValidity()){event.preventDefault();form.reportValidity();return;}button.disabled=true;root.querySelector('[data-priority-status]').textContent='Opening secure checkout…';});
    document.addEventListener('limitless:pricing-updated',sync);window.addEventListener('pageshow',sync);sync();
  });}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();document.addEventListener('shopify:section:load',initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["limitless-live-content"] && !Shopify.designMode) return;
  try {
    
if (!window.limitlessLiveFormatListener) {
  window.limitlessLiveFormatListener = true;
  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-live-format]');
    if (!trigger || !trigger.dataset.liveFormat) return;
    const select = document.querySelector('[data-live-format-select]');
    if (select && Array.from(select.options).some(option => option.value === trigger.dataset.liveFormat)) {
      select.value = trigger.dataset.liveFormat;
      select.dispatchEvent(new Event('change', {bubbles:true}));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["limitless-live-enquiry"] && !Shopify.designMode) return;
  try {
    
(function () {
  function focusLiveEnquiryStatus() {
    if (new URLSearchParams(window.location.search).has('concept_enquiry')) return;
    var status = document.querySelector('#live-enquiry .llv-form__errors, #live-enquiry .llv-form__status');
    if (status) {
      status.focus();
      status.scrollIntoView({ block: 'center' });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', focusLiveEnquiryStatus);
  } else {
    focusLiveEnquiryStatus();
  }
  document.addEventListener('shopify:section:load', focusLiveEnquiryStatus);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["limitless-priority-deposit"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initialize(){document.querySelectorAll('[data-priority-deposit]').forEach(root=>{
    if(root.dataset.ready)return;root.dataset.ready='true';
    const form=root.querySelector('[data-priority-form]'),select=root.querySelector('[data-priority-month]'),button=root.querySelector('[data-priority-submit]');
    const sync=()=>{const unlocked=!!window.LimitlessCoachingPricing?.getPrices();root.querySelector('[data-priority-purchase]').hidden=!unlocked;button.disabled=!unlocked||root.dataset.release!=='true';};
    const selected=new URLSearchParams(location.search).get('variant');if(selected&&Array.from(select.options).some(o=>o.value===selected&&!o.disabled))select.value=selected;
    form.addEventListener('submit',event=>{sync();if(button.disabled||!form.checkValidity()){event.preventDefault();form.reportValidity();return;}button.disabled=true;root.querySelector('[data-priority-status]').textContent='Opening secure checkout…';});
    document.addEventListener('limitless:pricing-updated',sync);window.addEventListener('pageshow',sync);sync();
  });}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();document.addEventListener('shopify:section:load',initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["limitless_coaching_menu"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  const PACKAGES = Object.freeze({
    private: { days:4 }, camp:{ days:3 },
    residency7:{ days:7 }, residency14:{ days:14 },
    residency21:{ days:21 }, residency28:{ days:28 }
  });
  const CAMP_MONTHS = Object.freeze(['2026-12','2027-01','2027-02']);
  const CAMP_LEVELS = Object.freeze(['Beginner','Intermediate','Experienced']);
  const isoDate = value => /^\d{4}-\d{2}-\d{2}$/.test(value || '') && !Number.isNaN(new Date(`${value}T12:00:00Z`).valueOf()) && new Date(`${value}T12:00:00Z`).toISOString().slice(0,10) === value;
  const addDays = (value, amount) => { const date = new Date(`${value}T12:00:00Z`); date.setUTCDate(date.getUTCDate()+amount); return date.toISOString().slice(0,10); };
  function preferredDateWindow(today) {
    if (!isoDate(today)) throw new Error('INVALID_TODAY');
    const [year,month] = today.split('-').map(Number);
    return { first:today>'2026-12-01'?today:'2026-12-01', last:new Date(Date.UTC(year,month+6,0)).toISOString().slice(0,10) };
  }
  function buildRequestModel(choice,today,prices=(typeof window!=='undefined'?window.LimitlessCoachingPricing?.getPrices():null)) {
    const pkg=Object.prototype.hasOwnProperty.call(PACKAGES,choice.package)?PACKAGES[choice.package]:null;
    const price=prices&&Number.isFinite(prices[choice.package])?prices[choice.package]:null;
    if (pkg && choice.package==='camp') return {package:'camp',total:price,days:pkg.days,rest:false,start:'',end:'',restDate:'',payment:'not_applicable',initial:0,balance:0,stay:'not_applicable',near:false,window:preferredDateWindow(today),requestEnabled:true,paymentEnabled:false};
    if (!pkg || !['half','full'].includes(choice.payment) || !['camping','caravan'].includes(choice.stay)) throw new Error('INVALID_CHOICE');
    const window=preferredDateWindow(today);
    const rest=choice.package==='private' && choice.rest===true;
    const days=pkg.days+(rest?1:0);
    const start=choice.start||'';
    if (start && (!isoDate(start)||start<window.first||start>window.last)) throw new Error('INVALID_START');
    const end=start?addDays(start,days-1):'';
    const near=!!start&&start<=addDays(today,15);
    const payment=near?'full':choice.payment;
    return { package:choice.package, total:price, days, rest, start, end, restDate:rest&&start?addDays(start,2):'', payment, initial:price===null?null:payment==='full'?price:price/2, balance:price===null?null:payment==='full'?0:price/2, stay:choice.stay, near, window, requestEnabled:true, paymentEnabled:false };
  }
  function buildContactPayload(choice,contact,today,reference) {
    const model=buildRequestModel(choice,today);
    const name=String(contact.name||'').trim(),email=String(contact.email||'').trim().toLowerCase();
    const phone=String(contact.phone||'').trim(),goals=String(contact.goals||'').trim();
    if(!name||name.length>120||/[\r\n]/.test(name))throw new Error('INVALID_CONTACT_NAME');
    if(email.length>254||! /^[A-Z0-9.!#$%&'*+\-/=?^_`{|}~]+@[A-Z0-9.-]+\.[A-Z]{2,63}$/i.test(email))throw new Error('INVALID_CONTACT_EMAIL');
    if(phone.length>50||/[\r\n]/.test(phone))throw new Error('INVALID_CONTACT_PHONE');
    if(goals.length>2000)throw new Error('INVALID_CONTACT_GOALS');
    if(!/^LM-[A-Za-z0-9-]+$/.test(reference||'')||reference.length>80)throw new Error('INVALID_REFERENCE');
    if(model.package==='camp') {
      const level=String(contact.level||'').trim();
      if(!CAMP_LEVELS.includes(level))throw new Error('INVALID_CAMP_LEVEL');
      if(!CAMP_MONTHS.includes(choice.month))throw new Error('INVALID_CAMP_MONTH');
      const video=String(contact.video||'');
      if(video){
        if(video.length>2000||/[\s\u0000-\u001f\u007f]/.test(video)||!/^https?:\/\//i.test(video))throw new Error('INVALID_CAMP_VIDEO');
        try { const url=new URL(video);if(!['http:','https:'].includes(url.protocol)||!url.hostname)throw new Error(); } catch(ignore) { throw new Error('INVALID_CAMP_VIDEO'); }
      }
      return {'Request type':'Rider Camp waitlist','Request reference':reference,'Name':name,'email':email,'Phone':phone,'Riding level':level,'Riding goals':goals,'Riding video link':video,'Coaching option':'Rider Camp','Package code':'camp','Duration':'3 coaching days','Preferred month':choice.month,'Camp price AUD':(Number.isFinite(model.total)?model.total.toFixed(2):'Not viewed; confirm pricing with Pat'),'Maximum riders':'4','Status':'Camp waitlist interest only; no place reserved, no booking or payment. Insurance and operating readiness pending.'};
    }
    if(choice.month==='flexible'?!!model.start:(!model.start||choice.month!==model.start.slice(0,7)))throw new Error('INVALID_DATES');
    const residency=model.package.startsWith('residency'),weeks=model.days/7;
    return {'Request type':'Coaching menu date request','Request reference':reference,'Name':name,'email':email,'Phone':phone,'Riding goals':goals,
      'Coaching option':model.package==='private'?'Private Experience':model.package==='camp'?'Rider Camp':'Rider Residency','Package code':model.package,
      'Duration':residency?`${weeks} week${weeks===1?'':'s'} / ${model.days} days`:model.package==='private'?`4 coaching days over ${model.days} calendar days`:'3 coaching days',
      'Preferred month':choice.month,'Preferred start':model.start||'Flexible','Preferred end':model.end||'Flexible',
      'Rest day':model.rest?`Yes${model.restDate?' - '+model.restDate:''}`:'No',
      'Accommodation preference':model.stay==='caravan'?'Caravan enquiry only; readiness, availability and any additional cost to be discussed':model.package==='private'?'Own camping setup; campsite included for agreed private-coaching stay dates':'Own camping setup; stay arrangements and inclusions by agreement',
      'Package total AUD':(Number.isFinite(model.total)?model.total.toFixed(2):'Not viewed; confirm pricing with Pat'),'Weekly rate AUD':residency?(Number.isFinite(model.total)?(model.total/weeks).toFixed(2):'Not viewed; confirm pricing with Pat'):'Not applicable',
      'Payment preference':model.payment==='half'?'50% after written date confirmation':'Full payment after written date confirmation',
      'Initial payment AUD':(Number.isFinite(model.initial)?model.initial.toFixed(2):'Not viewed; confirm pricing with Pat'),'Remaining balance AUD':(Number.isFinite(model.balance)?model.balance.toFixed(2):'Not viewed; confirm pricing with Pat'),'Status':'Non-binding enquiry only; no booking, reservation or payment. Insurance and operating readiness pending.'};
  }
  if (typeof module!=='undefined' && module.exports) { module.exports={PACKAGES,isoDate,addDays,preferredDateWindow,buildRequestModel,buildContactPayload}; return; }
  const initialize = scope => {
    scope.querySelectorAll('[data-coaching-menu]').forEach(root => {
      if (root.dataset.menuReady) return;
      root.dataset.menuReady='true';
      window.LimitlessCoachingPricing?.initialize(document);
      const copy=JSON.parse(root.querySelector('[data-menu-copy]').textContent);
      const q=selector=>root.querySelector(selector);
      const all=selector=>[...root.querySelectorAll(selector)];
      const packageSelect=q('[data-menu-package]');
      const payments=all('[data-menu-payment]');
      const rest=q('[data-menu-rest]');
      const stays=all('[data-menu-stay]');
      const month=q('[data-menu-month]');
      const campMonth=q('[data-camp-month]');
      const campLevel=q('[data-camp-level]');
      const campVideo=q('[data-camp-video]');
      const details=q('[data-date-details]');
      const calendar=q('[data-menu-calendar]');
      const days=q('[data-calendar-days]');
      const clear=q('[data-clear-dates]');
      const request=q('[data-request-button]');
      // Native Shopify enquiries only; payments remain locked.
      const requestReleaseApproved=true;
      const paymentReleaseApproved=false;
      const contactForm=q('[data-menu-contact]');
      const contactSuccess=!!q('[data-contact-success]');
      const requestReference='LM-'+crypto.randomUUID();
      let submissionInFlight=false;
      let selectedStart='';
      let residencyDuration='residency7';
      const initialOffer=new URL(location.href).searchParams.get('offer');
      if(initialOffer==='camp')packageSelect.value='camp';
      else if(initialOffer==='residency'||/^residency(?:7|14|21|28)$/.test(initialOffer||'')){packageSelect.value='residency';residencyDuration=initialOffer==='residency'?'residency7':initialOffer;}
      else if(initialOffer==='private')packageSelect.value='private';
      let lastDate='';
      let enquiryOpen=contactSuccess||!!q('.lcm-contact-error:not([hidden])');
      try { if(enquiryOpen&&sessionStorage.getItem('lcm-camp-waitlist-return')==='true')packageSelect.value='camp'; } catch(ignore) {}
      const today=()=>new Intl.DateTimeFormat('en-CA',{timeZone:'Australia/Sydney',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date());
      const money=value=>Number.isFinite(value)?new Intl.NumberFormat('en-AU',{style:'currency',currency:'AUD',maximumFractionDigits:0}).format(value).replace(/^\$/,'A$'):'Unlock pricing';
      const readable=value=>new Date(`${value}T12:00:00Z`).toLocaleDateString('en-AU',{day:'numeric',month:'short',year:'numeric',timeZone:'UTC'});
      const packageCopy=key=>key==='private'?{title:copy.private_title,intro:copy.private_intro,pills:[copy.private_days,copy.camping,copy.plan],items:[copy.included_1,copy.included_2,copy.included_3]}:key==='camp'?{title:copy.camp_title,intro:copy.camp_intro,pills:[copy.camp_days,copy.camp_plan],items:[copy.camp_included_1,copy.camp_included_2,copy.camp_included_3]}:{title:copy.residency_title,intro:copy.residency_intro,pills:[({residency7:copy.week_days,residency14:copy.twoweek_days,residency21:copy.threeweek_days,residency28:copy.fourweek_days})[key],copy.residency_plan],items:[copy.residency_included_1,copy.residency_included_2,copy.residency_included_3]};
      const setList=(element,items)=>element.replaceChildren(...items.map(text=>{const li=document.createElement('li');li.textContent=text;return li;}));
      const refreshMonths=()=>{
        const current=today();
        if (current===lastDate) return;
        lastDate=current;
        const window=preferredDateWindow(current);
        const previous=month.value;
        const [year,index]=window.first.split('-').map(Number);
        const cursor=new Date(Date.UTC(year,index-1,1,12));
        const options=[];
        while(cursor.toISOString().slice(0,7)<=window.last.slice(0,7)) {
          const option=document.createElement('option');option.value=cursor.toISOString().slice(0,7);option.textContent=cursor.toLocaleDateString('en-AU',{month:'long',year:'numeric',timeZone:'UTC'});options.push(option);cursor.setUTCMonth(cursor.getUTCMonth()+1);
        }
        const flexible=document.createElement('option');flexible.value='flexible';flexible.textContent=copy.month_flexible;options.push(flexible);month.replaceChildren(...options);
        month.value=options.some(o=>o.value===previous)?previous:options[0].value;
        if (selectedStart&&(selectedStart<window.first||selectedStart>window.last)) selectedStart='';
      };
      const renderCalendar=model=>{
        calendar.hidden=month.value==='flexible';days.replaceChildren();
        clear.hidden=!selectedStart;
        if(calendar.hidden){q('[data-calendar-status]').textContent=copy.flexible_summary;return;}
        const [year,index]=month.value.split('-').map(Number);
        const offset=(new Date(Date.UTC(year,index-1,1)).getUTCDay()+6)%7;
        const count=new Date(Date.UTC(year,index,0)).getUTCDate();
        q('[data-calendar-table]').setAttribute('aria-label',`${month.options[month.selectedIndex].textContent}, ${model.days}-${copy.day_block}`);
        let row;
        for(let cell=0;cell<Math.ceil((offset+count)/7)*7;cell++){
          if(cell%7===0){row=document.createElement('tr');days.append(row);}
          const td=document.createElement('td');row.append(td);const day=cell-offset+1;if(day<1||day>count)continue;
          const value=`${month.value}-${String(day).padStart(2,'0')}`;
          const button=document.createElement('button');button.type='button';button.className='lcm-calendar-day';button.dataset.date=value;button.textContent=String(day);
          button.disabled=value<model.window.first||value>model.window.last;
          const selected=!!model.start&&value>=model.start&&value<=model.end;
          button.setAttribute('aria-pressed',String(selected));button.dataset.edge=String(value===model.start||value===model.end);
          button.setAttribute('aria-label',`${readable(value)}${button.disabled?`, ${copy.unavailable_start}`:` ${copy.date_to} ${readable(addDays(value,model.days-1))}, ${model.days}-${copy.day_block}`}${selected?`, ${copy.selected_block}`:''}`);td.append(button);
        }
        q('[data-calendar-status]').textContent=model.start?`${readable(model.start)} – ${readable(model.end)}${model.rest?` · ${copy.rest_on} ${readable(model.restDate)}`:''}`:`${copy.select_start} · ${model.days}-${copy.day_block}`;
      };
      const stageKey=()=>packageSelect.value==='residency'?residencyDuration:packageSelect.value;
      const setStage=(open,historyMode='push',focus=true)=>{
        if(open&&stageKey()==='camp'&&!contactSuccess&&!q('.lcm-contact-error:not([hidden])')&&!CAMP_MONTHS.includes(campMonth.value))open=false;
        enquiryOpen=open;
        root.dataset.menuStage=open?'enquiry':'info';
        all('[data-info-only]').forEach(element=>element.hidden=open);
        q('[data-enquiry-stage]').hidden=!open;
        if(historyMode==='push'){const url=new URL(location.href);url.searchParams.set('offer',stageKey());url.searchParams.delete('contact_posted');url.hash=open?(stageKey()==='camp'?'camp-register-interest':'request-dates'):'offering-information';history.pushState({lcmStage:open?'enquiry':'info',lcmPackage:stageKey(),lcmCampMonth:stageKey()==='camp'?campMonth.value:''},'',url.pathname+url.search+url.hash);}
        if(focus){const target=open?q('.lcm-enquiry-heading h2'):q('[data-package-title]');target.scrollIntoView({behavior:'smooth',block:'start'});target.focus({preventScroll:true});}
      };
      const update=()=>{
        refreshMonths();
        const dateWindow=preferredDateWindow(today());
        if(selectedStart&&(!isoDate(selectedStart)||selectedStart<dateWindow.first||selectedStart>dateWindow.last||selectedStart.slice(0,7)!==month.value))selectedStart='';
        const model=buildRequestModel({package:packageSelect.value==='residency'?residencyDuration:packageSelect.value,payment:payments.find(p=>p.checked)?.value||'half',stay:stays.find(s=>s.checked)?.value||'camping',rest:rest.checked,start:selectedStart},today());
        const selected=packageCopy(model.package);
        const isCamp=model.package==='camp';
        if((root.dataset.campWaitlist==='true')!==isCamp){q('[data-contact-validation]').hidden=true;q('[data-contact-validation]').textContent='';}
        if(!isCamp){campMonth.value='';campLevel.value='';campVideo.value='';}
        root.dataset.campWaitlist=String(isCamp);
        q('[data-camp-groups]').hidden=!isCamp;all('[data-priority-option]').forEach(el=>el.hidden=!window.LimitlessCoachingPricing?.getPrices());q('.lcm-info-action').hidden=isCamp;q('[data-experience-priority]').hidden=isCamp||!window.LimitlessCoachingPricing?.getPrices();q('[data-experience-priority-link]').href=(model.package.startsWith('residency')?'/products/residency-priority-deposit':'/products/private-coaching-priority-deposit')+'?view=experience-priority';
        q('.lcm-enquiry-options').hidden=isCamp;q('.lcm-request-calendar').hidden=isCamp;
        q('[data-camp-waitlist-fields]').hidden=!isCamp;campMonth.disabled=!isCamp;campMonth.required=isCamp;campLevel.disabled=!isCamp;campLevel.required=isCamp;
        q('[data-camp-video-field]').hidden=!isCamp;campVideo.disabled=!isCamp;
        q('[data-contact-goals]').required=false;q('[data-goals-label]').textContent=isCamp?copy.camp_goals_label:copy.contact_goals;
        q('[data-enquiry-title]').textContent=isCamp?copy.request_camp:copy.enquiry_step_title;
        q('[data-enquiry-note]').textContent=isCamp?copy.camp_waitlist_note:copy.enquiry_step_note;
        q('[data-info-request-note]').textContent=isCamp?copy.camp_interest_note:copy.info_request_note;
        q('[data-contact-intro]').textContent=isCamp?copy.camp_waitlist_note:copy.contact_intro;
        q('[data-submit-label]').textContent=isCamp?copy.request_camp:copy.request_button;
        q('[data-process-title]').textContent=isCamp?copy.camp_process_title:copy.process_title;
        q('[data-process-body]').textContent=isCamp?copy.camp_waitlist_note:copy.process_body;
        q('[data-review-dates-label]').textContent=isCamp?copy.camp_month_label:copy.review_dates;
        q('[data-review-total-label]').textContent=isCamp?copy.camp_review_total:copy.review_total;
        q('[data-review-stay-row]').hidden=isCamp;q('[data-review-payment-row]').hidden=isCamp;q('[data-review-later-row]').hidden=isCamp;
        if(!submissionInFlight)q('[data-contact-payload]').replaceChildren();
        if(contactSuccess){q('[data-contact-success] h3').textContent=isCamp?copy.camp_contact_success_title:copy.contact_success_title;q('[data-contact-success] p').textContent=isCamp?copy.camp_contact_success_body:copy.contact_success_body;}
        const infoKey=model.package.startsWith('residency')?'residency':model.package;
        q('[data-info-heading]').textContent=copy[`info_${infoKey}_heading`];
        q('[data-info-description]').textContent=copy[`info_${infoKey}_description`];
        q('[data-info-best]').textContent=copy[`info_${infoKey}_best`];
        setList(q('[data-info-steps]'),[1,2,3].map(i=>copy[`info_${infoKey}_step_${i}`]));
        all('[data-info-photo]').forEach(photo=>photo.hidden=photo.dataset.infoPhoto!==infoKey);
        q('[data-info-cta]').textContent=copy[`request_${infoKey}`];

        all('[data-offering-card],[data-experience-tab]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.choosePackage===model.package||(button.dataset.choosePackage==='residency7'&&model.package.startsWith('residency')))));
        q('[data-residency-length]').hidden=!model.package.startsWith('residency');
        all('[data-residency-duration]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.choosePackage===model.package)));
        payments.forEach(p=>{if(!isCamp)p.checked=p.value===model.payment;p.disabled=isCamp||(model.near&&p.value==='half');});
        rest.disabled=model.package!=='private';q('[data-private-options]').hidden=model.package!=='private';q('[data-menu-rest-note]').hidden=!model.rest;
        q('[data-package-tag]').textContent=model.package==='private'?copy.private_tag:copy.more_tag;
        q('[data-package-title]').textContent=selected.title;q('[data-package-intro]').textContent=selected.intro;q('[data-package-price]').textContent=money(model.total);
        const isResidency=model.package.startsWith('residency');
        const pricesUnlocked=Number.isFinite(model.total);
        q('[data-package-price]').classList.toggle('coaching-price-locked',!pricesUnlocked);
        q('.lcm-price>span').hidden=!pricesUnlocked;
        all('[data-residency-choice-price]').forEach(element=>{const key=element.dataset.residencyChoicePrice;const value=window.LimitlessCoachingPricing?.getPrices()?.[key];element.textContent=Number.isFinite(value)?`${money(value)} total · ${money(value/(PACKAGES[key].days/7))} / week`:'Unlock pricing';});
        const weeklyRate=isResidency?(pricesUnlocked?`${money(model.total/(model.days/7))} ${copy.per_week}`:'Unlock pricing to view weekly rates'):'';
        q('[data-residency-rate]').hidden=!isResidency;q('[data-residency-rate]').textContent=weeklyRate;
        setList(q('[data-package-pills]'),selected.pills);setList(q('[data-package-inclusions]'),selected.items);
        q('[data-half-amount]').textContent=pricesUnlocked?`${money(model.total/2)} + ${money(model.total/2)} ${copy.remaining_due}`:'Unlock pricing';
        q('[data-full-amount]').textContent=money(model.total);
        q('[data-payment-amount]').textContent=`${money(model.initial)} ${copy.after_confirm_label}`;
        q('[data-payment-rule]').textContent=model.payment==='half'?copy.balance:copy.full_note;
        q('[data-near-start]').hidden=!model.near;
        q('[data-camping-inclusion]').textContent=model.package==='private'?copy.camping_included:copy.camping_arranged;
        q('[data-package-stay]').textContent=model.package==='private'?copy.stay_desc:copy.stay_other;
        q('[data-review-package]').textContent=`${selected.title} · ${model.rest?copy.private_rest_days:model.package==='private'?copy.private_days:model.package==='camp'?copy.camp_days:selected.pills[0]}`;
        q('[data-review-dates]').textContent=isCamp?(campMonth.options[campMonth.selectedIndex]?.textContent||copy.camp_month_placeholder):model.start?`${readable(model.start)} – ${readable(model.end)}`:month.value==='flexible'?copy.flexible_summary:copy.no_dates;
        q('[data-rest-property]').hidden=!model.rest;q('[data-property-rest]').hidden=!model.rest;
        q('[data-review-rest-row]').hidden=!model.rest;q('[data-review-rest]').textContent=model.restDate?readable(model.restDate):copy.rest_day_label;
        q('[data-review-stay]').textContent=model.stay==='caravan'?copy.caravan_request:model.package==='private'?copy.camping_request:copy.camping_other_request;
        q('[data-review-total]').textContent=pricesUnlocked?`${money(model.total)} AUD${isResidency?` · ${weeklyRate}`:''}`:'View pricing on the information screen, or ask Pat with your enquiry';
        q('[data-review-payment]').textContent=`${money(model.initial)} ${copy.due_after_confirmation}`;
        q('[data-review-later]').textContent=!pricesUnlocked?'Unlock pricing':model.balance?`${money(model.balance)} ${copy.remaining_due}`:copy.no_balance;
        root.dataset.requestState=JSON.stringify(model);
        request.disabled=!requestReleaseApproved||contactSuccess||submissionInFlight;request.setAttribute('aria-disabled',String(request.disabled));
        root.dataset.requestReleaseApproved=String(requestReleaseApproved);root.dataset.paymentReleaseApproved=String(paymentReleaseApproved);
        if(requestReleaseApproved&&!submissionInFlight)q('.lcm-preview-lock').textContent=isCamp?copy.camp_contact_test:copy.contact_test;
        renderCalendar(model);
        if(isCamp){calendar.hidden=true;days.replaceChildren();clear.hidden=true;q('[data-calendar-status]').textContent='';}
      };
      q('[data-open-dates]').addEventListener('click',event=>{event.preventDefault();details.open=true;q('.lcm-request').scrollIntoView({behavior:'smooth',block:'start'});details.querySelector('summary').focus({preventScroll:true});});
      packageSelect.addEventListener('change',()=>{selectedStart='';update();setStage(false);});
      all('[data-choose-package]').forEach(button=>button.addEventListener('click',()=>{if(button.dataset.choosePackage.startsWith('residency'))residencyDuration=button.dataset.choosePackage;packageSelect.value=button.dataset.choosePackage.startsWith('residency')?'residency':button.dataset.choosePackage;selectedStart='';update();if(button.hasAttribute('data-offering-card')||button.hasAttribute('data-experience-tab'))setStage(false);else{const url=new URL(location.href);url.searchParams.set('offer',stageKey());history.replaceState({...history.state,lcmPackage:stageKey()},'',url.pathname+url.search+url.hash);}}));
      q('[data-explore-caravan]').addEventListener('click',event=>{event.preventDefault();q('.lcm-accommodation').scrollIntoView({behavior:'smooth',block:'start'});q('[data-caravan-track]').focus({preventScroll:true});});
      payments.forEach(p=>p.addEventListener('change',update));stays.forEach(s=>s.addEventListener('change',update));
      rest.addEventListener('change',()=>{selectedStart='';update();});
      month.addEventListener('change',()=>{selectedStart='';update();});
      campMonth.addEventListener('change',()=>{update();history.replaceState({...history.state,lcmCampMonth:campMonth.value},'');});
      [campLevel,campVideo,q('[data-contact-goals]')].forEach(field=>field.addEventListener('input',()=>{if(!submissionInFlight)q('[data-contact-payload]').replaceChildren();}));
      days.addEventListener('click',event=>{const button=event.target.closest('button[data-date]');if(!button||button.disabled||!days.contains(button))return;selectedStart=button.dataset.date;update();days.querySelector(`[data-date="${selectedStart}"]`)?.focus();});
      days.addEventListener('keydown',event=>{const button=event.target.closest('button[data-date]');const move={ArrowLeft:-1,ArrowRight:1,ArrowUp:-7,ArrowDown:7}[event.key];if(!button||!move)return;event.preventDefault();const buttons=[...days.querySelectorAll('button')];let index=buttons.indexOf(button)+move;while(index>=0&&index<buttons.length){if(!buttons[index].disabled){buttons[index].focus();break;}index+=move;}});
      clear.addEventListener('click',()=>{selectedStart='';update();days.querySelector('button:not(:disabled)')?.focus();});
      q('[data-explore-property]').addEventListener('click',event=>{event.preventDefault();setStage(false);q('.lcm-property').scrollIntoView({behavior:'smooth',block:'start'});q('.lcm-property-heading h2').focus({preventScroll:true});});
      const propertyDialog=q('[data-property-dialog]');
      const propertyTiles=all('[data-property-open]');
      let propertyIndex=0,lastPropertyTrigger=null;
      const showProperty=index=>{
        propertyIndex=(index+propertyTiles.length)%propertyTiles.length;
        const tile=propertyTiles[propertyIndex],photo=tile.querySelector('img'),full=q('.lcm-lightbox-image');
        full.src=tile.dataset.fullImage;full.removeAttribute('srcset');full.alt=photo.alt;
        full.width=photo.naturalWidth;full.height=photo.naturalHeight;
        q('[data-property-caption]').textContent=tile.dataset.caption;
        q('[data-property-count]').textContent=`${propertyIndex+1} / ${propertyTiles.length}`;
      };
      propertyTiles.forEach((tile,index)=>tile.addEventListener('click',()=>{lastPropertyTrigger=tile;showProperty(index);if(!propertyDialog.open)propertyDialog.showModal();}));
      q('[data-property-close]').addEventListener('click',()=>propertyDialog.close());
      q('[data-property-previous]').addEventListener('click',()=>showProperty(propertyIndex-1));
      q('[data-property-next]').addEventListener('click',()=>showProperty(propertyIndex+1));
      propertyDialog.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();showProperty(propertyIndex+(event.key==='ArrowRight'?1:-1));}});
      propertyDialog.addEventListener('close',()=>lastPropertyTrigger?.focus({preventScroll:true}));
      contactForm.addEventListener('submit',event=>{
        if(!requestReleaseApproved||contactSuccess||submissionInFlight){event.preventDefault();return;}
        update();
        const error=q('[data-contact-validation]');error.hidden=true;error.textContent='';
        let payload;
        try {
          payload=buildContactPayload({package:packageSelect.value==='residency'?residencyDuration:packageSelect.value,payment:payments.find(p=>p.checked)?.value||'half',stay:stays.find(s=>s.checked)?.value||'camping',rest:rest.checked,start:selectedStart,month:packageSelect.value==='camp'?campMonth.value:month.value},{level:campLevel.value,video:campVideo.value,name:q('[data-contact-name]').value,email:q('[data-contact-email]').value,phone:q('[data-contact-phone]').value,goals:q('[data-contact-goals]').value},today(),requestReference);
        } catch(cause) {
          event.preventDefault();error.hidden=false;error.textContent=({INVALID_DATES:copy.contact_invalid_dates,INVALID_CAMP_MONTH:copy.camp_invalid_month,INVALID_CAMP_LEVEL:copy.camp_invalid_level,INVALID_CAMP_VIDEO:copy.camp_invalid_video})[cause.message]||copy.contact_invalid_details;
          if(cause.message==='INVALID_CAMP_MONTH')campMonth.focus();else if(cause.message==='INVALID_CAMP_LEVEL')campLevel.focus();else if(cause.message==='INVALID_CAMP_VIDEO')campVideo.focus();else if(cause.message==='INVALID_DATES'){details.open=true;details.querySelector('summary').focus();}else{const hook={INVALID_CONTACT_NAME:'name',INVALID_CONTACT_EMAIL:'email',INVALID_CONTACT_PHONE:'phone',INVALID_CONTACT_GOALS:'goals'}[cause.message];if(hook)q('[data-contact-'+hook+']').focus();}
          return;
        }
        q('[data-contact-name]').value=payload.Name;q('[data-contact-email]').value=payload.email;q('[data-contact-phone]').value=payload.Phone;q('[data-contact-goals]').value=payload['Riding goals'];
        if(packageSelect.value==='camp'){campLevel.value=payload['Riding level'];campVideo.value=payload['Riding video link'];}
        try { if(packageSelect.value==='camp')sessionStorage.setItem('lcm-camp-waitlist-return','true');else sessionStorage.removeItem('lcm-camp-waitlist-return'); } catch(ignore) {}
        const visible=new Set(['Name','email','Phone','Riding goals',...(packageSelect.value==='camp'?['Riding level','Riding video link']:[])]);
        q('[data-contact-payload]').replaceChildren(...Object.entries(payload).filter(([key])=>!visible.has(key)).map(([key,value])=>{const input=document.createElement('input');input.type='hidden';input.name=`contact[${key}]`;input.value=value;return input;}));
        // Let Shopify's normal CAPTCHA handler finish before locking a real native navigation.
        queueMicrotask(()=>{if(!event.defaultPrevented){submissionInFlight=true;request.disabled=true;request.setAttribute('aria-disabled','true');q('.lcm-preview-lock').textContent=packageSelect.value==='camp'?copy.camp_contact_sending:copy.contact_sending;}});
      });
      q('[data-start-enquiry]').addEventListener('click',()=>setStage(true));
      all('[data-camp-register]').forEach(button=>button.addEventListener('click',()=>{if(stageKey()!=='camp'||!CAMP_MONTHS.includes(button.dataset.campRegister))return;campMonth.value=button.dataset.campRegister;update();setStage(true);}));
      q('[data-back-information]').addEventListener('click',()=>setStage(false));
      window.addEventListener('popstate',event=>{
        const pkg=event.state?.lcmPackage;
        if(pkg&&PACKAGES[pkg]){if(pkg.startsWith('residency'))residencyDuration=pkg;packageSelect.value=pkg.startsWith('residency')?'residency':pkg;selectedStart='';campMonth.value=pkg==='camp'&&CAMP_MONTHS.includes(event.state?.lcmCampMonth)?event.state.lcmCampMonth:'';update();}
        setStage(event.state?.lcmStage==='enquiry'||contactSuccess,'none');
      });
      history.replaceState({...history.state,lcmStage:enquiryOpen?'enquiry':'info',lcmPackage:stageKey(),lcmCampMonth:stageKey()==='camp'?campMonth.value:''},'');
      setStage(enquiryOpen,'none',false);
      if(contactSuccess)q('[data-contact-success]').focus({preventScroll:false});
      document.addEventListener('limitless:pricing-updated',update);
      window.addEventListener('pageshow',update);document.addEventListener('visibilitychange',()=>{if(!document.hidden)update();});
      update();
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize(document),{once:true});else initialize(document);
  document.addEventListener('shopify:section:load',()=>initialize(document));
})();


  } catch(e) { console.error(e); }
})();
})();
